import React, { useState } from 'react';
import { Select, Divider, Input, Button, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import axios from 'axios';

/**
 * List picker with inline "create new list" in the dropdown footer.
 * Props: lists, setLists (to add the new list), value, onChange, placeholder, style.
 */
export default function ListSelect({ lists, setLists, value, onChange, placeholder = 'Select a list', style }) {
  const [name, setName] = useState('');
  const [creating, setCreating] = useState(false);

  const create = async () => {
    const n = name.trim();
    if (!n) return;
    setCreating(true);
    try {
      const res = await axios.post('/api/lists', { name: n });
      setLists(prev => [{ id: res.data.id, name: res.data.name }, ...prev]);
      onChange(res.data.id);
      setName('');
      message.success(`List "${res.data.name}" created`);
    } catch (e) {
      message.error(e.response?.data?.message || 'Could not create list');
    } finally {
      setCreating(false);
    }
  };

  return (
    <Select
      style={style || { width: '100%' }}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      showSearch
      optionFilterProp="label"
      options={(lists || []).map(l => ({ value: l.id, label: l.name }))}
      popupRender={menu => (
        <>
          {menu}
          <Divider style={{ margin: '8px 0' }} />
          <div style={{ display: 'flex', gap: 8, padding: '0 8px 4px' }}>
            <Input
              placeholder="New list name"
              value={name}
              onChange={e => setName(e.target.value)}
              onPressEnter={create}
              onKeyDown={e => e.stopPropagation()}    /* keep keystrokes out of the Select search */
              onClick={e => e.stopPropagation()}
            />
            <Button type="text" icon={<PlusOutlined />} loading={creating} onMouseDown={e => e.preventDefault()} onClick={create}>Create</Button>
          </div>
        </>
      )}
    />
  );
}
